export const USER_TIMEOUT_INITIAL_REFRESH_INTERVAL = 100;
export const USER_TIMEOUT_REFRESH_INTERVAL = 1000;
/** Pad the expiry time, so users don't see 401s */
export const USER_TIMEOUT_INTERVAL_PADDING = 3000;
export const USER_TIMEOUT_WARN_INTERVAL =
  300000 + USER_TIMEOUT_INTERVAL_PADDING;
